<div class="p-a-xl">
    <h2>Cipo DateTime fields</h2>

    <div fxLayout="row wrap" fxLayoutAlign="space-between">
        @for (item of form().controls | keyvalue; track $index) {
            <div fxFlex="32" class="m-b">
                <cipo-date-time [control]="item.value" />
            </div>
        }
    </div>

    <hr />
    Timezone:
    <pre>{{ timezone() }} (GMT{{timezoneOffsetHours() > 0 ? '+' : ''}}{{ timezoneOffsetHours() }})</pre>
    Browser timezone:
    <pre>{{ browserTimezone() }} (GMT{{browserTimezoneOffsetHours() > 0 ? '+' : ''}}{{ browserTimezoneOffsetHours() }})</pre>
    Last value changed as UTC:
    <pre>{{ lastValue() ?? ' ' }}</pre>
    Last value changed in browser timezone:
    <pre>{{ lastValueInBrowserTimezone() ?? ' ' }}</pre>
</div>
